import { onDomReady } from 'utils/onDomReady'
import { on } from 'delegated-events'
import { trackEvent } from 'api/index'

const destinationsList = () =>
  document.querySelector('.destinations-filter__list')

const getDestinationItems = () =>
  Array.from(document.querySelectorAll('.destinations-filter-item__wrap'))

const originalDestinationItems = []

function saveOriginalOrder() {
  const DestinationItems = getDestinationItems()
  originalDestinationItems.length = 0
  originalDestinationItems.push(...DestinationItems)
}

function restoreOriginalOrder() {
  const destination = destinationsList()
  if (!destination) return
  originalDestinationItems.forEach(item => {
    destination.appendChild(item)
  })
}

onDomReady(() => {
  saveOriginalOrder()
})

on('change', 'input[name="destinations-tab"]', e => {
  const input = e.target
  const { tag } = input.dataset
  if (!tag) return

  trackEvent('Marketing:Destinations:Category selected', { name: tag })

  restoreOriginalOrder()

  if (tag !== 'All') {
    getDestinationItems().forEach(item => {
      if (item.dataset.tag !== tag) {
        item.remove()
      }
    })
  }
})
